import clsx from "clsx";
import React, { useState, useEffect } from "react";

const heading = ({ settings }) => {
  if (!settings?.heading) return;

  return <h5>{settings?.heading}</h5>
}

const subcopy = ({ settings }) => {
  if (!settings?.subcopy) return;

  return <p>{settings?.subcopy}</p>
}

const cta_button = ({ settings }) => {
  if (!settings?.cta_text && !settings?.cta_url) return;

  return (
    <a
      href={settings.cta_url}
      className={`button ${settings.cta_style}`}
    >
      {settings.cta_text}
    </a>
  )
}

const blockComponents = { heading, subcopy, cta_button }

export default function CtaPopup({ settings }) {

  const [isOpen, setIsOpen] = useState(false);
  const { section_id, section, blocks } = settings;
  const sessionId = `has_viewed_${section_id}`;

  useEffect(() => {
    if (section.occurence === 'every-page-load') {
      setIsOpen(true);
      sessionStorage.setItem(sessionId, 'false');
      return;
    }

    const hasVisited = sessionStorage.getItem(sessionId);

    if (hasVisited !== 'true') {
      setIsOpen(true);
      sessionStorage.setItem(sessionId, 'true');
    }
  }, []);

  if (!isOpen) return;

  return (
    <div
      className={clsx("fixed top-0 left-0 w-full h-full flex justify-center items-center z-50 p-4", {
        'bg-[#00000066]': section.has_overlay
      })}
    >
      <div
        className="absolute top-0 left-0 w-full h-full bg-transparent"
        onClick={() => setIsOpen(false)}
      ></div>

      <div
        className="bg-white w-full flex flex-col justify-center items-center gap-4 p-6 relative z-50 text-center max-h-full"
        style={{
          maxWidth: `${section.max_width}px` || '400px'
        }}
      >
        <div
          className="absolute top-2 right-2 cursor-pointer"
          onClick={() => setIsOpen(false)}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M19.82 4.17999C19.58 3.94 19.1912 3.94 18.9513 4.17999L12 11.1313L5.04874 4.17999C4.80875 3.94 4.41996 3.94 4.17999 4.17999C3.94002 4.41998 3.94 4.80877 4.17999 5.04874L11.1313 12L4.17999 18.9513C3.94 19.1912 3.94 19.58 4.17999 19.82C4.41998 20.06 4.80876 20.06 5.04874 19.82L12 12.8687L18.9513 19.82C19.1912 20.06 19.58 20.06 19.82 19.82C20.06 19.58 20.06 19.1912 19.82 18.9513L12.8687 12L19.82 5.04874C20.06 4.80875 20.06 4.41996 19.82 4.17999Z"
              fill="#99A8B2"
            />
          </svg>
        </div>

        {blocks.map(block => {
          const BlockComponent = blockComponents[block.type];

          return (
            <BlockComponent
              key={block.id}
              settings={block.settings}
            />
          )  
        })}
      </div>
    </div>
  );
}
